"use client";

import { c as _c } from "react/compiler-runtime";
import MovieMeta from "./MovieMeta";
import MovieActions from "./MovieActions";
import GenreTags from "../_shared/GenreTags";
import LikedPercent from "../_shared/LikedPercent";
import type { SeriesDetail } from "@/types/series";
import type { Tag } from "@/types/movies";
import type { BackgroundImages } from "../_shared/contentMeta";
interface Props {
  series: SeriesDetail;
  images: BackgroundImages;
  year: string;
  countries: Tag[];
  genres: Tag[];
  subtitles: string;
  durationLabel: string;
  lastEpisodeUuid: string;
  hasActiveSubscription: boolean;
  hasActiveTicket: boolean;
  episodesLoading?: boolean;
  onBuyClick: () => void;
}
export default function SeriesMobileMeta(t0) {
  const $ = _c(26);
  const {
    series,
    images,
    year,
    countries,
    genres,
    subtitles,
    durationLabel,
    lastEpisodeUuid,
    hasActiveSubscription,
    hasActiveTicket,
    episodesLoading,
    onBuyClick
  } = t0;
  const t1 = series?.age_restriction?.name || "";
  const t2 = String(series?.imdb_rate ?? "");
  let t3;
  if ($[0] !== countries || $[1] !== durationLabel || $[2] !== subtitles || $[3] !== t1 || $[4] !== t2 || $[5] !== year) {
    t3 = <div className="w-full block lg:hidden"><MovieMeta ageLimit={t1} seasons={durationLabel} year={year} rating={t2} countries={countries} subtitles={subtitles} /></div>;
    $[0] = countries;
    $[1] = durationLabel;
    $[2] = subtitles;
    $[3] = t1;
    $[4] = t2;
    $[5] = year;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== genres) {
    t4 = <GenreTags tags={genres} className="flex lg:hidden mt-4 md:mt-6" />;
    $[7] = genres;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = series?.trailers?.[0]?.uuid || "";
  const t6 = series?.content_access || "";
  const t7 = series?.uuid || "";
  const t8 = series?.title_fa || series?.title_en || "";
  const t9 = series?.unique_code || "";
  const t10 = series?.coming_soon;
  let t11;
  if ($[9] !== episodesLoading || $[10] !== hasActiveSubscription || $[11] !== hasActiveTicket || $[12] !== images || $[13] !== lastEpisodeUuid || $[14] !== onBuyClick || $[15] !== t10 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t11 = <div className="w-full block lg:hidden"><MovieActions traileruuid={t5} status={t6} poster={images} uuid={t7} title={t8} uniqueCode={t9} lastEpisodeUuid={lastEpisodeUuid} onBuyClick={onBuyClick} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} comingSoon={t10} episodesLoading={episodesLoading} /></div>;
    $[9] = episodesLoading;
    $[10] = hasActiveSubscription;
    $[11] = hasActiveTicket;
    $[12] = images;
    $[13] = lastEpisodeUuid;
    $[14] = onBuyClick;
    $[15] = t10;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t3 || $[24] !== t4) {
    t12 = <>{t3}{t4}{t11}</>;
    $[22] = t11;
    $[23] = t3;
    $[24] = t4;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}